import { some } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../../components/forms/Checkbox'
import NumberField from '../../../../components/forms/NumberField'
import { hasValue } from '../../../../utils/NumberUtil'
import { EVENT_ACTION } from '../../../constants/PiezometryEventConstants'
import { getTitleCard, getYesOrNo } from '../EventFormUtils'
import { Card, CardContent, Grid, Typography } from '@mui/material'
import { TELECOM } from 'materiel/constants/MaterielConstants'
import { CardTable } from 'components/datatable/NewTable'

const EventTelecomCard = ({
    telecom = {},
    hasSignalTestAction = false,
    disabled = {},
    formActions = [],
    lastReplacementDate = '',
    setFormAction = () => {},
    onChangeTestSignal = () => {},
    getBooleanChoiceWithAction = () => {},
    displaySupply = true,
    hasPowerSupply = true,
}) => {
    const {
        telecomTypes,
        powerSupplyTypes,
    } = useSelector(store => ({
        telecomTypes: store.TelecomReducer.telecomTypes,
        powerSupplyTypes: store.PowerSupplyReducer.powerSupplyTypes,
    }), shallowEqual)
    const hasAction = some(['ORANGE', 'BOUYGUES', 'SFR'], fai => formActions.find(a => a.managementRule === `TEST_SIGNAL_${fai}` && telecom.id === a.materielId))
    const faiTable = ['Orange', 'Bouygues', 'SFR'].reduce((acc, val) => {
        const action = formActions.find(a => a.managementRule === `TEST_SIGNAL_${val.toUpperCase()}` && a.materielId === telecom.id)
        acc[val] = (
            <NumberField
                value={action ? action.value : null}
                onChange={v => setFormAction(`TEST_SIGNAL_${val.toUpperCase()}`, hasValue(v) && v, telecom.id, hasValue(v))}
                floatValue
                {...disabled}
            />
        )
        return acc
    }, {})
    const powerSupplyType = powerSupplyTypes.find(t => t.id === telecom.powerSupplyType)
    return (
        <Card>
            {getTitleCard(i18n.telecom, TELECOM, telecom, telecomTypes)}
            <CardContent>
                {
                    hasPowerSupply && (
                        <>
                            <Grid container spacing={1} alignItems={'center'}>
                                <Grid size={8}>
                                    {
                                        displaySupply && (
                                            <NumberField
                                                value={(formActions.find(a => a.managementRule === EVENT_ACTION.MESURE_TENSION_TELETRANSMISSION && a.materielId === telecom.id) || {}).value}
                                                title={i18n.transmissionVoltage}
                                                floatValue
                                                onChange={v => setFormAction(EVENT_ACTION.MESURE_TENSION_TELETRANSMISSION, v, telecom.id, hasValue(v))}
                                                {...disabled}
                                            />
                                        )
                                    }
                                </Grid>
                                <Grid offset={1} size={3}>
                                    <Checkbox
                                        label={i18n.replacement}
                                        checked={formActions.find(a => a.managementRule === EVENT_ACTION.REMPLACEMENT_PILES_TELETRANSMISSION && a.materielId === telecom.id)}
                                        onChange={v => setFormAction(EVENT_ACTION.REMPLACEMENT_PILES_TELETRANSMISSION, null, telecom.id, v)}
                                        active={disabled.active}
                                        disabled={powerSupplyType?.isNotReplaceable || disabled.disabled}
                                    />
                                </Grid>
                            </Grid>
                            <Typography variant='h6'>{`${i18n.lastReplacement} : ${lastReplacementDate}`}</Typography>
                        </>
                    )
                }
                <Grid container spacing={1} alignItems={'center'}>
                    <Grid size={8}>
                        <table>
                            {getYesOrNo()}
                            {getBooleanChoiceWithAction(i18n.transmissionTest, EVENT_ACTION.TEST_TRANSMISSION, telecom.id, disabled)}
                        </table>
                    </Grid>
                    <Grid offset={1} size={2}>
                        <Checkbox
                            label={i18n.signTest}
                            checked={hasAction || hasSignalTestAction}
                            onChange={onChangeTestSignal}
                            {...disabled}
                        />
                    </Grid>
                </Grid>
                {
                    (hasAction || hasSignalTestAction) && (
                        <CardTable
                            data={[faiTable]}
                            headers={['Orange', 'Bouygues', 'SFR']}
                        />
                    )
                }
            </CardContent>
        </Card>
    )
}

EventTelecomCard.propTypes = {
    telecom: PropTypes.object,
    hasSignalTestAction: PropTypes.bool,
    disabled: PropTypes.object,
    formActions: PropTypes.arrayOf(PropTypes.object),
    lastReplacementDate: PropTypes.string,
    setFormAction: PropTypes.func,
    onChangeTestSignal: PropTypes.func,
    getBooleanChoiceWithAction: PropTypes.func,
    displaySupply: PropTypes.bool,
    hasPowerSupply: PropTypes.bool,
}

export default EventTelecomCard